<app-header></app-header><div class="container">
  <div class="breadcrumbs mt-4">
    <div routerLink="/">Главная</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div routerLink="/">Экспертиза промышленной безопасности</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div routerLink="/expprombez">Проведение экспертизы промышленной безопасности (ЭПБ)</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div routerLink="/expprombez/epb-gazoprovodov">Экспертиза промышленной безопасности газопроводов</div>

  </div>
  <div class="row">
    <h1 class="w-100 mt-70">Экспертиза промышленной безопасности газопроводов
    </h1>
    <p>Согласно <strong>Приложению №1 к Федеральному закону от 21.07.1997 № 116-ФЗ</strong> к опасным производственным объектам относятся объекты, на которых производят, перерабатывают, применяют, транспортируют и пр. опасные вещества, в количествах, указанных в <strong>Приложении №2</strong> к вышеуказанному закону. Для обеспечения технологических процессов при работе с опасными веществами могут использоваться газопроводы: магистральные, наружные и внутренние.</p>

    <h2>В каких случаях требуется экспертиза промышленной безопасности газопроводов</h2>

    <p>Газопроводы, применяемые на опасных производственных объектах для транспортировки опасных веществ, подлежат экспертизе промышленной безопасности:</p>

    <ul class="marked ml-50">
      <li>до начала их применения;</li>
      <li>по завершении срока эксплуатации, установленного проектной документацией или экспертизой промышленной безопасности;</li>
      <li>при отсутствии информации о сроке эксплуатации в паспорте и пр. документации;</li>
      <li>после осуществления их ремонта с изменением конструкции, который&nbsp;требуется, в том числе после аварий и инцидентов на ОПО.</li>
    </ul>

    <h2>Наши эксперты:</h2>

    <ul class="link-arrow">
      <li>- В сжатые сроки организуют&nbsp;проведение экспертизы промышленной безопасности газопроводов</li>
      <li>- Произведут выезд на опасные производственные объекты, расположенные в Москве и в регионах</li>
      <li>- Проведут экспертизу документации на консервацию, ликвидацию и техническое перевооружение газопроводов</li>
      <li>- Окажут комплексное сопровождение от сбора документации до внесения заключения в реестр</li>
      <li>- Дадут разъяснения по каждому этапу</li>
    </ul>
    <app-recall-form heading="Требуется экспертиза промышленной безопасности газопровода и нет времени изучать детали? Напишите Ваш вопрос, и наши эксперты Вас проконсультируют."></app-recall-form>

    <h2>Этапы проведения экспертизы промышленной безопасности газопроводов:</h2>

    <ol class="marked" style="margin-left: 14px;">
      <li>Сбор и предоставление заказчиком ЭПБ всей необходимой документации.</li>
      <li>Обеспечение заказчиком доступа к зданиям, сооружениям, техническим устройствам и пр.</li>
      <li>Проведение экспертизы промышленной безопасности газового оборудования.</li>
      <li>Анализ документации, обследование и прочие аналитические процедуры, осуществляемые экспертами.</li>
      <li>Оформление заключения экспертизы промышленной безопасности.</li>
      <li>Предоставление заключения ЭПБ в федеральный орган исполнительной власти для внесения в государственный реестр.</li>
    </ol>

    <p>Срок проведения экспертизы промышленной безопасности газопровода зависит от правил проведения, объема (протяженности) и территориальной удаленности объекта.</p>

    <p><strong>Наши эксперты работают в области промышленной безопасности более 20 лет. Качественно и оперативно мы проведем экспертизу промышленной безопасности и подготовим комплект документов для регистрации ЭПБ в Ростехнадзоре. Стоимость рассчитывается индивидуально.</strong></p>
    <app-atomka-calc heading="Получить консультацию и последующий расчет стоимости проведения экспертизы промышленной безопасности газопроводов"></app-atomka-calc>
    <app-reviews-block class="w-100"></app-reviews-block>
  </div>
</div>
<app-footer></app-footer>
